// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"381":"88ee1dd8","3541":"51ba63bc","5308":"c5e260fd","7274":"0eb2d22a","8436":"0eb2d22a","9553":"ec89a5ed"}[chunkId] + ".chunk.css";
};